import React, { useState } from 'react';
import { Styles } from './style';
import Person from '@assets/images/person.png';
import { contactFormData } from './contactFormData';
import { useNavigate } from 'react-router-dom';
import AuthenticatedLayout from '@screens/Authenticated/Layout/Layout';
import PageControl from '@components/PageControl';

const FormContactScreen: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(3);
  const [searchTerm, setSearchTerm] = useState('');

  const normalizeText = (text: string) => {
    return text.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  };

  const filteredContacts = contactFormData.filter((contact) => {
    const normalizedSearchTerm = normalizeText(searchTerm);
    return (
      normalizeText(contact.name).includes(normalizedSearchTerm) ||
      normalizeText(contact.email).includes(normalizedSearchTerm) ||
      normalizeText(contact.phone).includes(normalizedSearchTerm)
    );
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentContacts = filteredContacts.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const totalPages = Math.ceil(filteredContacts.length / itemsPerPage);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const navigate = useNavigate();

  return (
    <AuthenticatedLayout>
      <h1>CONTATOS VIA SITE</h1>
      <Styles.RectangleBar />
      <h1
        style={{
          marginTop: '-20px'
        }}>
        Contato
      </h1>
      <Styles.SectionFilters>
        <Styles.FlexContainer>
          <Styles.ShowText>Mostrar</Styles.ShowText>
          <Styles.SelectContainer>
            <select value={itemsPerPage} onChange={handleItemsPerPageChange}>
              <option value={3}>3</option>
              <option value={6}>6</option>
              <option value={9}>9</option>
              <option value={12}>12</option>
            </select>
          </Styles.SelectContainer>
          <Styles.RecordsText>Registros</Styles.RecordsText>
        </Styles.FlexContainer>
        <Styles.SearchContainer>
          <Styles.SearchInput
            type="text"
            placeholder="Buscar por nome, sobrenome, e-mail ou telefone..."
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </Styles.SearchContainer>
      </Styles.SectionFilters>
      {currentContacts.map((contact, index) => (
        <Styles.UserCard key={index}>
          <Styles.UserIcon>
            <img
              src={Person}
              alt="User Icon"
              style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%'
              }}
            />
          </Styles.UserIcon>
          <Styles.UserInfo>
            <Styles.UserName>
              <h1>{contact.name}</h1>
            </Styles.UserName>
            <Styles.UserContact>
              {contact.subject} | {contact.message}
            </Styles.UserContact>
          </Styles.UserInfo>
          <Styles.Buttons>
            <button
              onClick={() =>
                navigate(
                  `/area-do-corretor/clientes/contato/${indexOfFirstItem + index}`
                )
              }>
              VISUALIZAR
            </button>
            <button>EXCLUIR</button>
          </Styles.Buttons>
        </Styles.UserCard>
      ))}
      <PageControl
        currentPage={currentPage}
        totalPages={totalPages}
        onChange={handlePageChange}
      />
    </AuthenticatedLayout>
  );
};

export default FormContactScreen;
